// extracted by mini-css-extract-plugin
export default {"notFor":"mapStates_notFor__xj52Q"};